import {
  AmenitiesOutdoorCampchairIcon,
  AmenitiesShadeIcon,
  EHeadingStyleVariant,
  ETextStyleVariant,
  GeneralClickIcon,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

type TWhyPeopleLoveOutdoorsyStep = {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
};

const Step = ({ Icon, title, description }: TWhyPeopleLoveOutdoorsyStep) => (
  <div className="flex flex-1 gap-6 sm:flex-col">
    <div className="flex w-[35px] sm:w-auto">
      <Icon className="w-[34px] h-[34px]" />
    </div>
    <div className="flex-1">
      <Text variant={ETextStyleVariant.MediumBold} className="mb-2 md:text-[20px]">
        {title}
      </Text>
      <Text variant={ETextStyleVariant.SmallRegular} className="md:text-base">
        {description}
      </Text>
    </div>
  </div>
);

export const WhyPeopleLoveOutdoorsy = () => {
  const intl = useIntl();

  const steps: TWhyPeopleLoveOutdoorsyStep[] = [
    {
      title: intl.formatMessage({ defaultMessage: 'One-and-Done Booking', id: 'okUZCT' }),
      description: intl.formatMessage({
        defaultMessage:
          'Book your RV and site together in a single checkout. No juggling websites or reservations.',
        id: 'T5xfDk',
      }),
      Icon: GeneralClickIcon,
    },
    {
      title: intl.formatMessage({ defaultMessage: 'Show Up and Start Relaxing', id: 'dB5B0M' }),
      description: intl.formatMessage({
        defaultMessage: 'Your RV is already there, set up, and ready to go. Just arrive and enjoy.',
        id: 'h1RI4d',
      }),
      Icon: AmenitiesOutdoorCampchairIcon,
    },
    {
      title: intl.formatMessage({ defaultMessage: 'Destinations Worth the Trip', id: 'RqfAMx' }),
      description: intl.formatMessage({
        defaultMessage:
          'Take advantage of premium resorts with amazing amenities in prime locations.',
        id: '+pTBp9',
      }),
      Icon: AmenitiesShadeIcon,
    },
  ];
  return (
    <div>
      <Heading
        variant={EHeadingStyleVariant.H2Alt}
        className="mb-3 not-italic font-normal text-left text-850 md:text-900 md:mb-4 leading-[35px]">
        <FormattedMessage defaultMessage="Why People Love Outdoorsy Escapes" id="6fm43M" />
      </Heading>
      <div className="flex flex-col mt-8 md:mt-10 md:flex-row gap-6 lg:gap-28">
        {steps.map((step, index) => (
          <Step key={index} {...step} />
        ))}
      </div>
    </div>
  );
};
